var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border-plus"},[_c('img',{attrs:{"src":_vm.currentImg,"alt":"","srcset":""},on:{"mouseenter":function($event){_vm.currentImg = _vm.hoverImg},"mouseleave":function($event){_vm.currentImg = _vm.defaultImg}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-edf8a924","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bussiness/widges/button/borderPlus.vue
// module id = null
// module chunks = 